<template>
  <fragment>
    <!-- <v-flex xs12 sm12 md6> -->

    <v-menu
      v-model="menu"
      v-show="showAD"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-show="showAD"
          dense
          v-model="date"
          :label="label"
          prepend-icon="event"
          readonly
          v-on="on"
          :error-messages="errorMessages"
        >
          <template v-slot:append>
            <v-btn @click="changedate" small tile text color="primary">{{
              $store.getters.datetype
            }}</v-btn>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-show="showAD"
        v-model="date"
        @input="menu = false"
      ></v-date-picker>
    </v-menu>
    <!-- </v-flex>
    <v-flex xs12 sm12 md6 class="inline-block pad0">-->
    <div v-show="showBS">
      <nepali-date-picker
        :error-messages="errorMessages"
        v-model="dateBS"
        :label="label"
      ></nepali-date-picker>
    </div>
    <!-- </v-flex> -->
  </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import nepaliDate from "../../shared/nepalidate";
import NepaliDatePicker from "./NepaliDatePicker";
export default {
  name: "engnepdatepicker",
  props: ["value", "label", "errorMessages"],
  components: {
    NepaliDatePicker,
    Fragment,
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    date: {
      get: function() {
        return this.value;
      },
      set: function(value) {
        this.$emit("input", value);
      },
    },
    dateBS: {
      get: function() {
        let converteddate = nepaliDate.convertToNepaliDate(this.value);
        return converteddate;
      },
      set: function(value) {
        let converteddate = nepaliDate.convertToEnglishDate(value);
        if (converteddate != this.value) {
          this.$emit("input", converteddate);
        }
      },
    },
    showAD() {
      return this.$store.getters.datetype == "AD";
    },
    showBS() {
      return this.$store.getters.datetype == "BS";
    },
  },
  methods: {
    changedate() {
      let datetype = this.$store.getters.datetype == "AD" ? "BS" : "AD";
      this.$store.dispatch("changeDateType", datetype);
    },
  },
};
</script>

<style scoped>
.inline-block {
  display: inline-block;
}
</style>
